var messageMap = {};
export var deprecated = function deprecated(message) {
  if (!messageMap[message]) {
    messageMap[message] = true; // eslint-disable-next-line no-console

    console.warn(message);
  }
};